import { authorizedGetCall } from "./APIsService";

export const getReferrals = (search = null) => {
  return new Promise((resolve, reject) => {
    let url = `referrals`;
    if (search) {
      url += `?searchQuery=${encodeURIComponent(search)}`;
    }

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
